import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DefaultDrawer from '../../../../../components/Drawers/Default';
import { DOCUMENT_TYPES } from '../../../utils/documents';

const EMPTY_FILTERS = {
  document_type: '',
  added_after: '',
  added_before: ''
};

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <DefaultDrawer
      isOpen={isOpen}
      toggle={toggle}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.type')}: </Label>
          <Input
            type="select"
            value={filtersData.document_type}
            onChange={(e) => setFiltersData({...filtersData, document_type: e.target.value})}
          >
            <option value="">{t('common.all')}</option>
            {DOCUMENT_TYPES.map(type => (
              <option value={type.value}>{type.label}</option>
            ))}
          </Input>
        </FormGroup>
        <hr />
        <FormGroup>
          <Label>{t('common.addedAfter')}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.filter')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.cancel')}
        </DefaultButton>
      </div>
    </DefaultDrawer>
  );
}

export default FiltersDrawer;